<template>
  <div id="internationalSwift">
    <div class="contact_title">
      <h2>{{ $t('deposit.default.deposit') }}</h2>
      <p></p>
    </div>
    <div class="form_internationalAndAu" v-if="formFlag">
      <!-- <strong>{{ $t('deposit.intSwift.header') }}</strong> -->
      <strong>{{
        langTranslate('deposit.default.channels.', paymentDetails.merchant_variable.description_title)
      }}</strong>
      <el-form :model="cpsForm" ref="cpsForm" :rules="cpsRules">
        <div class="box">
          <div class="form_content_box">
            <div class="info_box">
              <!-- FX-IR (Iran) -->
              <div v-if="paymentDetails.payment_method === 'T00100_069'">
                <h3 class="desc_title">
                  {{ $t('deposit.method.desc', { method: paymentDetails.merchant_variable.description_title }) }}
                </h3>
                <ul>
                  <li>{{ $t('deposit.method.inst1') }}</li>
                  <li>{{ $t('deposit.banktransfer.inst3') }}</li>
                </ul>
              </div>
              <ul v-else-if="paymentDetails.payment_method === 'T00600_501'">
                <li>{{ $t('deposit.banktransfer.inst1', { platform: $config.info.fullName }) }}</li>
                <li>{{ $t('deposit.banktransfer.inst4') }}</li>
                <li>{{ $t('deposit.banktransfer.inst3') }}</li>
                <li>{{ $t('deposit.banktransfer.inst5', { currency: paymentDetails.actual_currency_code }) }}</li>
              </ul>
              <!-- normal methods -->
              <ul v-else>
                <li>{{ $t('deposit.banktransfer.inst1', { platform: $config.info.fullName }) }}</li>
                <li>{{ $t('deposit.banktransfer.inst2') }}</li>
                <li>{{ $t('deposit.banktransfer.inst3') }}</li>
                <li>{{ $t('deposit.banktransfer.inst6') }}</li>
              </ul>
            </div>
            <!-- FX-IR (Iran) -->
            <div v-if="paymentDetails.payment_method === 'T00100_069'" class="img">
              <img
                :src="paymentLogo(paymentDetails.payment_method, paymentDetails.actual_currency_code, countryCode)"
                alt="logo"
              />
            </div>
            <p>{{ $t('deposit.intSwift.options') }}</p>
            <ul class="clearfix account_number">
              <li>
                <AccountNumber
                  :supportedCurrenciesList="tradeAccountCurrencies"
                  :disabled="isDisabled"
                  @setCurrency="setCurrency"
                  @setAccountNumber="setAccountNumber"
                ></AccountNumber>
              </li>
            </ul>
            <ul class="clearfix bank_info" v-show="isShow">
              <li v-bind:key="item.title" v-for="item in bankInfos">
                <span class="title_name">{{ getBankInfosTranslation(item) }}</span>
                <span class="value_info">{{ item.value }}</span>
              </li>
            </ul>
            <div class="warn_info">
              <p>{{ refInfo }}</p>
            </div>
          </div>
        </div>
        <div class="box">
          <strong class="title">
            {{ $t('deposit.default.sendReceipt') }}
          </strong>
          <div class="form_content_box">
            <div v-if="paymentDetails.payment_method === 'T00100_069'" class="info">
              <p>{{ $t('deposit.fxir.inst1') }}</p>
              <p>{{ $t('deposit.intSwift.bussDayInfo') }}</p>
              <p>{{ $t('deposit.fxir.inst2') }}</p>
            </div>
            <div v-else class="info">
              <p>{{ $t('deposit.intSwift.desc2') }}</p>
              <p>{{ $t('deposit.intSwift.bussDayInfo') }}</p>
            </div>
            <div class="info">
              <p>{{ $t('deposit.banktransfer.currencyConversion') }}</p>
            </div>
            <ul class="clearfix">
              <li>
                <InputForm
                  :label="$t('common.field.accNum')"
                  name="accNum"
                  :disabled="true"
                  v-model="cpsForm.accountNumber"
                ></InputForm>
              </li>
              <li>
                <numeric-input
                  v-model="cpsForm.amount"
                  :currency="accountCurrency"
                  :precision="2"
                  :label="$t('common.field.amt')"
                  :readOnly="isDisabled"
                  name="amount"
                  @blur="onAmountBlur"
                ></numeric-input>
              </li>
            </ul>

            <ul class="clearfix">
              <template v-if="cpsForm.attachVariables.length > 0">
                <li
                  :class="index % 2 == 0 ? 'fl' : 'fr'"
                  v-for="(type, index) in cpsForm.attachVariables"
                  :key="type.key"
                >
                  <!-- Email Field -->
                  <InputForm
                    :label="type.field_name"
                    :name="'attachVariables.' + index + '.value'"
                    :testId="type.type"
                    v-model="cpsForm.attachVariables[index].value"
                    :disabled="isDisabled"
                    v-if="type.field_type == 'input_field' && type.type == 'email'"
                    rules="email"
                  ></InputForm>

                  <!-- Input Field -->
                  <DynamicRestrictInput
                    :label="getFieldLabel(type.field_name)"
                    :name="'attachVariables.' + index + '.value'"
                    :testId="type.type"
                    :restrictionType="type.restriction_type"
                    v-model="cpsForm.attachVariables[index].value"
                    :maxlength="type.field_length"
                    v-else-if="type.field_type == 'input_field'"
                  >
                  </DynamicRestrictInput>

                  <!-- Dropdown List -->
                  <SelectForm
                    :label="type.field_name"
                    :name="'attachVariables.' + index + '.value'"
                    :disabled="isDisabled"
                    v-model="cpsForm.attachVariables[index].value"
                    v-if="type.field_type == 'dropdown_list' && type.type == 'depositor'"
                    rules="depositor"
                  >
                    <el-option
                      v-for="(value, name) in type.field_content"
                      :label="value.desc"
                      :value="value.value"
                      :key="name"
                    ></el-option>
                  </SelectForm>

                  <SelectForm
                    :label="type.field_name"
                    :name="'attachVariables.' + index + '.value'"
                    :disabled="isDisabled"
                    v-model="cpsForm.attachVariables[index].value"
                    v-if="type.field_type == 'dropdown_list' && type.type == 'bank'"
                    rules="depositor"
                  >
                    <el-option
                      v-for="(value, name) in type.field_content"
                      :label="value.bank_name"
                      :value="value.bank_code"
                      :key="name"
                    ></el-option>
                  </SelectForm>
                </li>
              </template>
              <li :class="cpsForm.attachVariables.length % 2 == 0 ? 'fl' : 'fr'">
                <InputForm
                  :label="$t('common.field.imptNotes')"
                  :disabled="isDisabled"
                  name="applicationNotes"
                  v-model="cpsForm.notes"
                >
                </InputForm>
              </li>
              <li class="fl" v-if="showExchangeRates">
                <el-form-item>
                  <p class="mb-2">
                    <span class="required_icon">*</span>
                    {{
                      $t('deposit.default.rate.rate', {
                        oldCurrency: accountCurrency,
                        newCurrency: newCurrencyRate
                      })
                    }}
                    <span>{{ rate }}</span>
                  </p>
                  <p class="mb-2">
                    <span class="required_icon">*</span>
                    {{
                      bankCurrencySupport
                        ? this.cpsForm.depositCurrency
                        : accountCurrency === 'USC' && this.paymentDetails.unique_currency
                        ? 'USD'
                        : paymentDetails.currency_code
                    }}:
                    <span>{{ rateChange }}</span>
                  </p>
                  <p v-if="paymentDetails.payment_method == 'T00600_060'">
                    <span class="required_icon">*</span>
                    {{
                      $t('common.field.maximumAmountTip2', {
                        currency: paymentDetails.actual_currency_code,
                        amount: '30,000'
                      })
                    }}
                  </p>
                  <p v-if="paymentDetails.payment_method === 'T00600_501'">
                    <span>{{
                      $t('deposit.default.localAEDTransferOnly', { currency: paymentDetails.actual_currency_code })
                    }}</span>
                  </p>
                </el-form-item>
              </li>
            </ul>
            <ul class="clearfix">
              <li>
                <el-form-item prop="uploadFile">
                  <vUpload
                    :action="uploadURL"
                    :limit="6"
                    v-on:updateFileInfo="updateFileInfo"
                    data-testid="updateFileInfo"
                  ></vUpload>
                </el-form-item>
              </li>
            </ul>
            <DepositDiscount
              v-if="isLoyalty && showDepositVouncher"
              v-bind="depositDiscountProps"
              @setDepositDiscount="setDepositDiscount"
              :discRateChange="getDisRateChange()"
            ></DepositDiscount>
            <div class="form_button">
              <el-button
                class="el-button blue_button"
                :loading="loading"
                :disabled="isDisabled"
                @click="submitCpsForm()"
                data-testid="submit"
              >
                {{ $t('common.button.submit') }}
              </el-button>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <Result v-if="successFlag">{{ $t('deposit.default.successMsg') }}</Result>
  </div>
</template>

<script>
import NumericInput from '@/components/NumericInput';
import AccountNumber from '@/components/form/AccountNumber';
import DynamicRestrictInput from '@/components/form/DynamicRestrictInput';
import Result from '@/components/Result';
import vUpload from '@/components/vUpload';
import cpsMixin from '@/mixins/cpsDeposit';
import mixin from '@/mixins/page/deposit';
import { apiExchangeRate } from '@/resource';
import { apiCps_payment } from '@/resource/cps';
import { validateEmail } from '@/util/validation';
import {
  bankInfoData,
  translation,
  SupportBankCurrencyList,
  hideDepositVouncher
} from '@/constants/payment/depositSetting.json';
import { countryCodeEnum } from '@/constants/country';
import fieldLabelList from '@/constants/depositFieldLabel';

export default {
  name: 'internationalBankCps',
  components: { NumericInput, AccountNumber, Result, vUpload, DynamicRestrictInput },
  mixins: [mixin, cpsMixin],
  data() {
    const checkUploadFile = (rule, value, callback) => {
      if (!(this.fileList.length > 0)) callback(new Error(this.$t('common.formValidation.fileReceipt')));
      else callback();
    };
    const validateAmount = (rule, value, callback) => {
      if (value === '' || !Number(value)) {
        callback(new Error(this.$t('common.formValidation.amtReq')));
      } else if (parseFloat(value) < this.minLimit) {
        callback(
          new Error(
            this.$t('common.formValidation.amtLarger', {
              minLimit: this.minLimit,
              currency: this.accountCurrency
            })
          )
        );
      } else if (parseFloat(value) > this.maxLimit) {
        callback(
          new Error(
            this.$t('common.formValidation.amtLess', {
              maxLimit: this.maxLimit,
              currency: this.accountCurrency
            })
          )
        );
      } else {
        callback();
      }
    };
    return {
      uploadURL: '/api/file/cps-upload',
      formFlag: true,
      successFlag: false,
      isShow: false,
      refInfo: null,
      bankInfos: [],
      fileList: [],
      ibtBank: null,
      cpsForm: {
        accountNumber: '',
        amount: '',
        depositCurrency: 'USD',
        attachVariables: [],
        mandatory: [],
        notes: ''
      },
      selectRules: {
        required: true,
        message: this.$t('common.formValidation.common'),
        trigger: 'change'
      },
      inputRules: {
        required: true,
        message: this.$t('common.formValidation.common'),
        trigger: 'blur'
      },
      cpsRules: {
        accountNumber: [
          {
            required: true,
            message: this.$t('common.formValidation.accReq'),
            trigger: 'change'
          }
        ],
        email: [
          {
            required: true,
            message: this.$t('common.formValidation.emailReq'),
            trigger: 'blur'
          },
          {
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        amount: [
          {
            required: true,
            validator: validateAmount,
            trigger: 'blur'
          }
        ],
        uploadFile: [
          {
            validator: checkUploadFile,
            required: true,
            trigger: 'change'
          }
        ]
      },
      paymentChannel: '',
      exchangeRates: false,
      showExchangeRates: false,
      bankCurrencySupport: false,
      showDepositVouncher: true,
      rate: 0.0,
      minLimit: 50,
      formName: 'cpsForm',
      activeIndex: 0,
      isDisabled: false
    };
  },
  computed: {
    paymentDetails() {
      return this.$store.state.cps.currentPayment;
    },
    paymentTypes() {
      let paymentTypes = this.$store.state.cps.payment.child;
      return paymentTypes;
    },
    tradeAccountCurrencies() {
      let arr = [];
      let types = this.paymentTypes.map(el => {
        let val = el.merchant_variable?.trade_account;
        return val ? val.split(',') : [];
      });
      types.forEach(type => {
        arr.push(...type);
      });
      return arr;
    },
    rateChange() {
      return (Math.round(this.rate * this.cpsForm.amount * 100) / 100).toFixed(2);
    },
    newCurrencyRate() {
      if (this.paymentDetails.unique_currency) {
        if (this.bankCurrencySupport) {
          return this.cpsForm.depositCurrency;
        } else if (this.accountCurrency === 'USC') {
          return 'USD';
        } else {
          return this.paymentDetails.actual_currency_code;
        }
      }

      return this.paymentDetails.currency_code;
    },
    countryCode() {
      return parseInt(this.$store.state.common.countryCode);
    }
  },
  watch: {
    accountCurrency() {
      this.dertermineBankCurrencySupport();
      this.updateLimit();
      this.isShow = true;
      this.setPaymentTypes();
    }
  },
  methods: {
    setAccountNumber(accountNumber) {
      this.cpsForm.accountNumber = accountNumber;
    },
    setPaymentTypes() {
      this.activeIndex = this.paymentTypes.findIndex(el => el.actual_currency_code === this.accountCurrency);
      if (this.activeIndex === -1) this.activeIndex = 0;
      this.handleSelectIndex(this.activeIndex);
    },
    getFieldLabel(val) {
      const i18nKey = this.getI18nKey(val);
      if (this.$te(i18nKey) || this.$te(i18nKey, 'en_US')) {
        if (i18nKey === 'common.field.paymentAccName' || i18nKey === 'common.field.paymentAccNum')
          return this.$t(i18nKey, { name: val.split(' ')[0] });
        return this.$t(i18nKey);
      }
      return val;
    },
    getI18nKey(val) {
      let label = fieldLabelList[val];
      return label ? label : val;
    },
    updateFileInfo(fileInfo) {
      this.fileList = fileInfo.fileList;
      this.$refs['cpsForm'].validateField('uploadFile');
    },
    success(msg) {
      window.location = msg;
    },
    submitCpsForm() {
      this.$refs['cpsForm'].validate(valid => {
        if (valid) {
          this.loading = true;
          this.submitDeposit()
            .then(result => {
              this.cpsHandling(result);
            })
            .catch(err => {
              this.loading = false;
              this.errorMessage(this.$t('deposit.default.failed'));
            });
        } else {
          return false;
        }
      });
    },
    cpsHandling(result) {
      if (result.data.code == 0 && result.data.data) {
        this.formFlag = false;
        this.successFlag = true;
      } else {
        this.loading = false;
        if (result.data.code !== 562) {
          this.errorMessage(this.$t('deposit.default.failed'));
        }
      }
    },
    submitDeposit() {
      // Get email_address
      let emailAddressIndex = -1;
      if (this.cpsForm.attachVariables) {
        emailAddressIndex = this.cpsForm.attachVariables.findIndex(function (type) {
          return type.key == 'psp_account';
        });
      }

      // Map attach variables
      let attachVariables = {};
      if (this.cpsForm.attachVariables) {
        this.cpsForm.attachVariables.map(a => {
          if (a.field_type === 'read_only') attachVariables['ibt_bank'] = this.ibtBank;
          else if (a.key === 'file_path') attachVariables[a.key] = this.convertToAttachVariablesFileList(this.fileList);
          else attachVariables[a.key] = a.value;
        });
      }

      const determineActualCurrencyCode = () => {
        return this.accountCurrency === 'USC' ? 'USD' : this.accountCurrency;
      };

      const getCurrencyNumber = (item, currency) => {
        if (item.unique_currency && currency) {
          const uniqueCurrencyConfig = item.unique_currency;
          let configObject = {};
          uniqueCurrencyConfig.forEach(config => {
            if (config.actual_currency_code === currency) {
              configObject = { ...config };
            }
          });
          return configObject.currency_number;
        }
        return item.currency_number;
      };

      const getActualCurrencyNumber = (item, currency) => {
        if (item.unique_currency && currency) {
          const uniqueCurrencyConfig = item.unique_currency;
          let configObject = {};
          uniqueCurrencyConfig.forEach(config => {
            if (config.actual_currency_code === currency) {
              configObject = { ...config };
            }
          });
          return configObject.actual_currency_number;
        }
        return item.actual_currency_number;
      };

      return apiCps_payment(
        {
          mt4Account: this.cpsForm.accountNumber,
          operateAmount: this.cpsForm.amount,
          applicationNotes: this.cpsForm.notes,
          depositAmount: this.exchangeRates ? this.rateChange : this.cpsForm.amount,
          cpsCode: this.paymentDetails.payment_method,
          orderCurrency: this.paymentDetails.unique_currency
            ? getCurrencyNumber(this.paymentDetails, determineActualCurrencyCode())
            : this.paymentDetails.currency_number,
          actualCurrency: this.paymentDetails.unique_currency
            ? getActualCurrencyNumber(this.paymentDetails, determineActualCurrencyCode())
            : this.paymentDetails.actual_currency_number,
          mandatory: this.cpsForm.mandatory ? this.cpsForm.mandatory.toString() : [],
          attachVariables: JSON.stringify(attachVariables),
          redemptionCode: this.voucherID,
          email: emailAddressIndex != -1 ? this.cpsForm.attachVariables[emailAddressIndex].value : '',
          ibtBank: this.ibtBank,
          fileList: this.fileList
        },
        this.token
      );
    },
    queryRate() {
      let fromCurrency = this.accountCurrency;

      if (this.cryptoPayment.includes(this.paymentDetails.payment_method)) {
        this.toCurrencyCode = 'USD';
      } else if (this.bankCurrencySupport && this.paymentDetails.unique_currency) {
        this.toCurrencyCode = this.cpsForm.depositCurrency;
      } else if (this.paymentDetails.unique_currency && this.accountCurrency === 'USC') {
        this.toCurrencyCode = 'USD';
      } else if (
        this.paymentDetails.payment_method == 'T00600_053' &&
        this.paymentDetails.actual_currency_code == 'JPY' &&
        this.paymentDetails.actual_currency_number == 392
      ) {
        this.toCurrencyCode = 'JPY_Non_real_time';
      } else {
        this.toCurrencyCode = this.paymentDetails.currency_code;
      }

      apiExchangeRate({
        fromCurrency: fromCurrency,
        toCurrency: this.toCurrencyCode
      })
        .then(resp => {
          if (resp.data.code == 0) {
            this.rate = resp.data.data;
          }
        })
        .catch(err => {
          this.errorMessage(
            this.$t('deposit.default.rate.result.rateError', {
              oldCurrency: this.accountCurrency,
              newCurrency: this.paymentDetails.actual_currency_code
            })
          );
        });
    },
    determineExchangeRate() {
      // check if exchange rates is required
      if (!this.accountCurrency) {
        return;
      }

      if (this.paymentDetails.unique_currency) {
        if (this.bankCurrencySupport && this.accountCurrency !== this.paymentDetails.unique_currency) {
          this.showExchangeRates = true;
          this.exchangeRates = true;
          this.queryRate();
        } else if (this.accountCurrency === 'USC') {
          this.showExchangeRates = true;
          this.exchangeRates = true;
          this.queryRate();
        } else {
          this.rate = 1;
          this.exchangeRates = false;
          this.showExchangeRates = false;
        }
      } else {
        let currency = this.accountCurrency === 'USC' ? 'USD' : this.accountCurrency;
        if (currency != this.paymentDetails.currency_code) {
          this.showExchangeRates = true;
          this.exchangeRates = true;
          this.queryRate();
        } else {
          this.rate = 1;
          this.showExchangeRates = false;
          this.exchangeRates = false;
        }
      }
    },
    handleSelectIndex(index) {
      this.activeIndex = index;

      if (this.paymentTypes.length > 0) {
        let payment = this.paymentTypes[index];
        this.cpsForm.attachVariables = payment.attach_variable
          ? payment.attach_variable.filter(f => f.hasOwnProperty('field_type'))
          : '';

        this.setBankInfo(this.cpsForm.attachVariables);

        this.cpsForm.mandatory = payment.attach_variable ? payment.attach_variable.filter(f => f.length > 0)?.[0] : '';
        this.$store.dispatch('cps/actionSetCurrentPayment', payment);

        this.dertermineBankCurrencySupport();
        this.determineExchangeRate();
        this.updateLimit();
        this.hideDepositVouncher();
      }
    },
    updateLimit() {
      let newLimit = false;

      if (!this.accountCurrency) {
        return;
      }

      if (this.paymentDetails.merchant_variable?.limit) {
        this.paymentDetails.merchant_variable?.limit.some(limit => {
          if (this.accountCurrency == limit.account_currency) {
            this.maxLimit = limit.max;
            this.minLimit = limit.min;
            newLimit = true;
            return true;
          }
        });
      }

      if (!newLimit) {
        this.maxLimit = 99999999.99;
        this.minLimit = 50.0;
      }
    },
    dertermineBankCurrencySupport() {
      if (SupportBankCurrencyList.includes(this.paymentDetails.payment_method)) {
        this.bankCurrencySupport = true;
      } else {
        this.bankCurrencySupport = false;
      }
    },
    hideDepositVouncher() {
      if (hideDepositVouncher.includes(this.paymentDetails.merchant_variable.parent)) this.showDepositVouncher = false;
    },
    getLabelSwitch(merchantVariable) {
      if (typeof merchantVariable.label_switch === 'undefined') return true;
      return merchantVariable.label_switch;
    },
    getBankInfosTranslation(val) {
      if (!val) return;
      return bankInfoData[val.obj] ? this.$t(bankInfoData[val.obj]) : val.name;
    },
    getTranslation(val) {
      if (!val) return;
      return translation[val.value] ? this.$t(translation[val.value]) : val.value;
    },
    setBankInfo(attachVariables) {
      if (!attachVariables) return;
      const data = attachVariables.filter(el => el.field_type === 'read_only')[0].field_content[0];
      this.ibtBank = data.value;
      this.bankInfos = data.field_content.filter(el => bankInfoData[el.obj]);
      this.refInfo = this.getTranslation(...data.field_content.filter(el => el.obj === 'paymentref'));
    },
    getDisRateChange() {
      let specialExchangeRate = false;

      if (this.countryCode === countryCodeEnum.JAPAN && this.accountCurrency === 'JPY') {
        specialExchangeRate = true;
      }

      if (this.exchangeRates) {
        return {
          currency: this.toCurrencyCode,
          rate: this.rate,
          dp: 2,
          case: 5,
          paymentMethod: this.paymentDetails.payment_method
        };
      } else if (specialExchangeRate) {
        return { rate: this.discountRate, dp: 2, case: 5, paymentMethod: this.paymentDetails.payment_method };
      } else {
        return { rate: this.rate, dp: 2, case: 5, paymentMethod: this.paymentDetails.payment_method };
      }
    },
    setDefaultPayment() {
      if (this.paymentTypes.length > 0) {
        //get last selected payment index
        let paymentIndex = this.paymentTypes.findIndex(i => {
          return (
            i.merchant_variable.label == this.paymentDetails.merchant_variable?.label &&
            this.getLabelSwitch(i.merchant_variable)
          );
        });
        // get first available payment if there is no default value
        if (paymentIndex == -1)
          paymentIndex = this.paymentTypes.findIndex(i => {
            return this.getLabelSwitch(i.merchant_variable);
          });
        if (paymentIndex == -1) {
          this.handleSelectIndex(0);
          this.isDisabled = true;
        } else {
          this.activeIndex = paymentIndex;
          this.handleSelectIndex(this.activeIndex);
        }
      }
    },
    convertToAttachVariablesFileList(list) {
      return list.map(el => {
        let url = new URL(el);
        return url.pathname;
      });
    }
  },
  mounted() {
    this.setDefaultPayment();
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/deposit/internationalAndAu.scss';
.form_internationalAndAu {
  position: relative;
}
.box {
  --base: 18px;
  .info_box {
    .desc_title {
      padding-bottom: var(--base);
    }
    ul {
      display: block !important;
      @include rtl-sass-prop(padding-left, padding-right, 25px);
      li {
        margin-bottom: 10px;
        list-style: decimal;
        @include rtl-sass-prop(padding-left, padding-right, 0.5em);

        &::marker {
          color: #055bff;
        }
      }
    }
  }
  .img {
    position: absolute;
    top: 40px;
    @include rtl-sass-prop(right, left, 60px);
    @media all and (max-width: 768px) {
      position: relative;
      top: unset;
      @include rtl-sass-prop(right, left, unset);
      display: flex;
      justify-content: center;
      border-top: 1px solid #cccfd4;
      padding-block: var(--base);
      margin-block: calc(var(--base) * 2);
    }
  }
  .account_number {
    margin-top: 40px;
  }
}

@media (max-width: 1200px) {
}
</style>
